import { createRouter, createWebHistory } from 'vue-router';
import Cookies from 'js-cookie'; // 引入 js-cookie 库

//首页
import HelloWorld from '@/components/HelloWorld.vue'
// pdf转word
import pdf2word from '@/views/pdf2word/index.vue';
// 文档管理
import document from '@/views/document/index.vue';
// 登录管理
import login from '@/views/login/index.vue';
// 测试
import test from '@/views/test.vue';
// 市场价格
import marketPrices from '@/views/market/marketPrices.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        component: HelloWorld,
    },
    {
        path: '/pdf2word',
        name: 'pdf2word',
        component: pdf2word,
    },
    {
        path: '/document',
        name: 'document',
        component: document,
        meta: { requiresAuth: true } // 标记该路由需要身份验证
    },
    {
        path: '/login',
        name: 'login',
        component: login,
    },
    {
        path: '/test',
        name: 'test',
        component: test,
    },
    {
        path: '/marketPrices',
        name: 'marketPrices',
        component: marketPrices,
        meta: { requiresAuth: true }
    },
];

const router = createRouter({
    history: createWebHistory('/lifexmz'),
    routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
    const token = Cookies.get('token'); // 从 Cookies 中获取 token
    // 检查 to.meta 是否存在，并且 requiresAuth 是否为 true
    const isAuthRequired = to.meta && to.meta.requiresAuth;
    if (isAuthRequired && !token) {
        // 如果访问需要身份验证的页面且没有 token
        sessionStorage.setItem('redirectUrl', to.fullPath); // 记录要跳转的页面地址
        next('/login'); // 跳转到登录页
    } else {
        next(); // 正常跳转
    }
});

export default router;
